import { cardMeaning, cardName, type Deck } from '@planning-session/shared';
import { CardFace } from './ui/CardFace.js';
import styles from './Hand.module.css';

export interface HandProps {
  readonly deck: Deck;
  readonly selected: string | null;
  readonly locked: boolean;
  onPick: (value: string) => void;
  onRetract: () => void;
}

export function Hand({ deck, selected, locked, onPick, onRetract }: HandProps) {
  return (
    <div className={styles.dock}>
      <div className={styles.inner}>
        <span className={styles.hint}>
          {locked
            ? 'Cards are on the table'
            : selected === null
              ? `Pick a card · ${deck.label}`
              : 'Tap your card again to take it back'}
        </span>

        <div className={styles.cards}>
          {deck.cards.map((value) => {
            const isSelected = value === selected;
            const meaning = cardMeaning(deck, value);
            return (
              <button
                key={value}
                type="button"
                className={`${styles.card} ${isSelected ? styles.selected : ''}`}
                disabled={locked}
                aria-pressed={isSelected}
                aria-label={cardName(value, meaning)}
                onClick={() => (isSelected ? onRetract() : onPick(value))}
              >
                {/* The label above already says all of this; the face is decoration to a reader. */}
                <span className={styles.value} aria-hidden="true">
                  <CardFace value={value} iconSize={22} />
                </span>
                {meaning && (
                  <span className={styles.meaning} aria-hidden="true">
                    {meaning.short}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
